import {
  openOneLiveChat,
  setOneLiveChatLauncherVisible,
} from '@belong/integrations-belong-one-chat/utils';

export function setSupportChatLauncherVisible(visible: boolean) {
  window.Intercom?.('update', { hide_default_launcher: !visible });
  setOneLiveChatLauncherVisible(visible);
}

/** Opens the Belong One chat, the only live chat. Does nothing until it is ready. */
export function openSupportChat() {
  setOneLiveChatLauncherVisible(true);
  openOneLiveChat();
}

export function isSameOrigin(origin: string | undefined, host: string) {
  try {
    return !!origin && new URL(origin).host === host;
  } catch {
    return false;
  }
}
